import { render } from "./PersonalReport.vue?vue&type=template&id=52865756&scoped=true"
import script from "./PersonalReport.vue?vue&type=script&lang=js"
export * from "./PersonalReport.vue?vue&type=script&lang=js"

import "./PersonalReport.vue?vue&type=style&index=0&id=52865756&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52865756"]])

export default __exports__